import React from 'react'
import { IssuerLogos } from '../../../images'

export const ClosedApplicationList = (props) => {
  const { customer_applications = [], t } = props
  if(!customer_applications.length) return null
  return(
    <section styleName="app-closed">
      <h2 styleName="app-closed__header heading heading--large">Recently Closed Applications</h2>
      <table styleName="app-closed__table responsive-table">
        <tbody>
          <tr>
            <th styleName="label label--large">Product</th>
            <th styleName="label label--large">Closed Date</th>
          </tr>
          {customer_applications.map((app, ndx) => {
            const { product_type, application_owner_pretty, closed_at_pretty, id} = app
            return(
              <tr key={ndx}>
                <td data-th="Product">{application_owner_pretty} {t(`product.types.${product_type}`)}<small><em styleName="app-closed__info-status">App. ID: {id}</em></small></td>
                <td data-th="Closed Date">{closed_at_pretty}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </section>
  )
}
